"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FeaturesEnum;

(function (FeaturesEnum) {
  FeaturesEnum["payments"] = "payments";
})(FeaturesEnum = exports.FeaturesEnum || (exports.FeaturesEnum = {}));